import React from 'react';
import ReactDOM from 'react-dom';
import PanelComponentNL from './PanelNL/PanelComponentNL';


// uncomment this block to "defer" ReactDOM.render and expose it globaly
window.PanelComponentNL = {
    mount: (props, container) => {
        ReactDOM.render(<PanelComponentNL {...props} />, container);
    },
    unmount: (container) => {
        ReactDOM.unmountComponentAtNode(container);
    }
}

console.log("PanelComponentNL versión: v0.0.1.7")